<!-- Routed views go here -->
<app-header *ngIf="showHeaderAndFooter"></app-header>
<div class="vsp-container eclaim-root-container">
  <router-outlet></router-outlet>
</div>
<app-footer *ngIf="showHeaderAndFooter"></app-footer>
